import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import 'animate.css';
import 'swiper/css';

import './Assets/css/baguetteBox.min.css';
// import './Assets/css/Montserrat.css';
import './Assets/css/vanilla-zoom.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

